<!-- 我的相册 -->
<template>
  <div class="photo-page">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">我的相册</div>
      </el-col>
      <el-col class="clear" :span="12">
        <span class="rt creatPhotoBtn" @click="dialogFormVisible = true">+创建相册</span>
      </el-col>
    </el-row>
    <div v-if="myPhoneList.length == 0">
      <empty :acceptEmptyData="acceptEmptyData"></empty>
      <p style="text-align: center;margin: 30px 0"><span class="rt creatPhotoBtn" style="float: none" @click="dialogFormVisible = true">+创建相册</span></p>
    </div>
    <el-row class="repeatable" v-if="myPhoneList.length > 0">
      <photo :myPhoneList="myPhoneList" @showState="acceptState"></photo>
    </el-row>

    <el-dialog title="添加修改相册" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" class="demo-ruleForm" label-width="80px" label-position="left">
        <el-form-item label="标题" prop="title">
          <el-input placeholder="请输入您的标题" v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" :rows="2" placeholder="请输入您的描述，方便记录您旅程点滴！" v-model="form.description">
          </el-input>
        </el-form-item>
        <el-form-item prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="1">公开</el-radio>
            <el-radio label="0">不公开</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button v-if="showUpdateBtn == false" type="primary" @click="addPhoto('form')">确 定</el-button>
          <el-button v-if="showUpdateBtn == true" type="primary" @click="updatePhoto('form')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { selectUserPhotoBook, insertUserPhotoBook, deleteUserPhotoBook, updateUserPhotoBook } from "api/apis";
import http from 'api/api'
import photo from '../../components/homeCommon/photo'
import empty from '../../components/common/empty'

import $ from "jquery";
export default {
  components: {
    photo,
    empty
  },
  data () {
    return {
      acceptEmptyData: {
        from: 'showImageInfor',
        msg: '您还未创建相册，可先创建相册哦～'
      },
      user_code: localStorage.getItem("pbw_user_pc_uid"),
      loginKey: localStorage.getItem("pbw_user_pc_loginKey"),
      secretKey: localStorage.getItem("pbw_user_pc_secretKey"),

      myPhoneList: [],
      dialogFormVisible: false,
      rules: {
        title: [
          { required: true, message: '请输入相册标题', trigger: 'blur' },
          { min: 1, max: 5, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入相册描述', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择是否要公开', trigger: 'change' }
        ]
      },
      form: {
        title: '',
        description: '',
        status: null,
      },
      showUpdateBtn: false,
      updatePhotoObj: {},
    }
  },
  methods: {
    acceptState (data) {//编辑图片
      if (data.state == 'del') {
        this.$confirm('确认要删除相册吗？相册内的照片全部也会被删除！')
          .then(_ => {
            deleteUserPhotoBook({ code: data.code }).then((res) => {
              if (res.code == '000000') {
                this.$message.success('删除成功了哦！')
                this.getPhotoList()
              } else {
                this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
              }
            })
          })
          .catch(_ => { });

      } else if (data.state == 'edit') {
        for (let val in data) {
          for (let val_f in this.form) {
            if (val == val_f) {
              this.form[val_f] = data[val]
            }
          }
        }
        this.updatePhotoObj = data
        this.showUpdateBtn = true
        this.dialogFormVisible = true
      } else {
        console.log("skdkskdf")
        this.$router.push({
          name: showImageInfor,
          query: {
            code: item.code
          }
        })
      }
    },
    addPhoto (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.userCode = localStorage.getItem('pbw_user_pc_uid')
          insertUserPhotoBook(this.form).then((res) => {
            if (res.code == '000000') {
              this.dialogFormVisible = false
              this.$message.success('相册创建成功！')
              this.getPhotoList()
            } else {
              this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updatePhoto () {
      console.log(this.updatePhotoObj, "更新")
      this.form.code = this.updatePhotoObj.code
      updateUserPhotoBook(this.form).then((res) => {
        if (res.code == '000000') {
          this.dialogFormVisible = false
          this.$message.success('相册修改成功！')
          this.getPhotoList()
        } else {
          this.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
        }
      })
    },
    getPhotoList () {
      http.GET('/jw-function', {
        module: 'home',
        operation: 'getPhotoAlbumList',
        uid: localStorage.getItem('pbw_user_pc_uid'),
      }).then((res) => {
        this.myPhoneList = res.data
      })

    },
  },
  mounted () {
    this.getPhotoList()
  }
}
</script>
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
@import '../../scss/demo.scss';
.photo-page .dashed {
  border-bottom: 1px dashed #f1f1f1;
  padding-bottom: 20px;
  margin-bottom: 25px;
}
.photo-page .title1 {
  font-size: 18px;
  color: #333;
}
.photo-page .title1::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 27px;
  border-radius: 5px;
  vertical-align: bottom;
  background-color: #f16202;
  margin-right: 20px;
}
.photo-page .title2,
.photo-page .title2 em {
  text-align: right;
  font-size: 14px;
  color: #959595;
  line-height: 27px;
}
.photo-page .repeatable {
  padding-bottom: 20px;
}
.photo-page .repeatable .name {
  font-size: 14px;
  text-align: right;
  line-height: 40px;
}
/*相册*/
.creatPhotoBtn {
  color: #f60;
  border: 1px solid #f60;
  font-size: 16px;
  padding: 2px 16px;
  border-radius: 50px;
  cursor: pointer;
  &:hover {
    background: #f60;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/photoPage.vue